export function doesAllSelectionsHaveSamePrePackId(selections) {
    return selections.length > 0
        && selections.every(x => !!x.prePackId && x.prePackId === selections[0].prePackId);
}
//# sourceMappingURL=doesAllSelectionsHaveSamePrePackId.js.map